/**
 * Handdoekhaakjes.nl — Shopify JavaScript
 * Coolblue-stijl webshop
 * Features: BTW-toggle, Shopify Ajax Cart API, mobile nav, gallery, quantity, variants
 */
(function () {
  'use strict';

  /* =============================================
     BTW TOGGLE — incl./excl. 21%
  ============================================= */
  let vatInclusive = true;

  const vatToggle = document.getElementById('vatToggle');
  const vatWrap   = document.getElementById('vatWrap');

  function formatEuroPlain(val) {
    return '€ ' + parseFloat(val).toFixed(2).replace('.', ',');
  }

  function updateVAT() {
    const isIncl = vatInclusive;

    // Toggle UI state
    if (vatToggle) {
      vatToggle.setAttribute('aria-checked', isIncl.toString());
    }
    if (vatWrap) {
      vatWrap.classList.toggle('vat-state-excl', !isIncl);
    }

    // Update label opacity
    const exclLabel = document.getElementById('vatLabelExcl');
    const inclLabel = document.getElementById('vatLabelIncl');
    if (exclLabel) exclLabel.style.opacity = isIncl ? '0.65' : '1';
    if (inclLabel) inclLabel.style.opacity = isIncl ? '1' : '0.65';

    // PDP main price
    document.querySelectorAll('.pdp-price-current.price-incl').forEach(el => {
      const pIncl = parseFloat(el.getAttribute('data-price-incl'));
      const pExcl = parseFloat(el.getAttribute('data-price-excl'));
      if (isNaN(pIncl) || isNaN(pExcl)) return;
      el.textContent = formatEuroPlain(isIncl ? pIncl : pExcl);
    });

    // Product card styled prices (with sup/sub)
    document.querySelectorAll('.price-current.price-incl').forEach(el => {
      const pIncl = parseFloat(el.getAttribute('data-price-incl'));
      const pExcl = parseFloat(el.getAttribute('data-price-excl'));
      if (isNaN(pIncl) || isNaN(pExcl)) return;
      const val   = isIncl ? pIncl : pExcl;
      const parts = val.toFixed(2).split('.');
      el.innerHTML = `€\u2009${parts[0]}<sup>,</sup><sub>${parts[1]}</sub>`;
    });

    // Old prices
    document.querySelectorAll('.price-old-incl').forEach(el => {
      const oIncl = parseFloat(el.getAttribute('data-old-incl'));
      const oExcl = parseFloat(el.getAttribute('data-old-excl'));
      if (isNaN(oIncl) || isNaN(oExcl)) return;
      el.textContent = formatEuroPlain(isIncl ? oIncl : oExcl);
    });

    // Bulk table prices
    document.querySelectorAll('.bulk-price').forEach(el => {
      const i = parseFloat(el.getAttribute('data-incl'));
      const e = parseFloat(el.getAttribute('data-excl'));
      if (!isNaN(i) && !isNaN(e)) {
        el.textContent = formatEuroPlain(isIncl ? i : e);
      }
    });

    // Bulk total column
    document.querySelectorAll('.bulk-total').forEach(el => {
      const i = parseFloat(el.getAttribute('data-incl'));
      const e = parseFloat(el.getAttribute('data-excl'));
      if (!isNaN(i) && !isNaN(e)) {
        el.textContent = '€ ' + (isIncl ? i : e)
          .toFixed(2)
          .replace('.', ',')
          .replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      }
    });

    // VAT notes
    const vatText = isIncl ? 'Inclusief 21% BTW' : 'Exclusief BTW (21%)';
    document.querySelectorAll('.vat-note-text').forEach(el => {
      if (el.id === 'pdpVatNote') {
        el.textContent = vatText;
      } else {
        const extra = el.textContent.split('·')[1];
        el.textContent = vatText + (extra ? ' ·' + extra : '');
      }
    });

    // Bulk section VAT label text
    ['bulkVatLabel', 'staffelVatLabel'].forEach(id => {
      const el = document.getElementById(id);
      if (el) el.textContent = isIncl ? 'incl. BTW' : 'excl. BTW';
    });
  }

  if (vatToggle) {
    vatToggle.addEventListener('click', () => {
      vatInclusive = !vatInclusive;
      updateVAT();
    });
  }

  // Init
  updateVAT();


  /* =============================================
     CART — Shopify Ajax Cart API
  ============================================= */
  const cartCountEl = document.getElementById('cartCount');
  const cartToast   = document.getElementById('cartToast');
  const cartToastMsg = document.getElementById('cartToastMsg');
  let toastTimer;

  function showToast(msg) {
    if (!cartToast) return;
    if (cartToastMsg) cartToastMsg.textContent = msg;
    cartToast.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => cartToast.classList.remove('show'), 3200);
  }

  function updateCartCount(count) {
    if (!cartCountEl) return;
    cartCountEl.textContent = count;
    cartCountEl.style.transform = 'scale(1.4)';
    setTimeout(() => { cartCountEl.style.transform = ''; }, 250);
  }

  function addToCartShopify(variantId, quantity, name, btnEl) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity || 1 })
    })
    .then(res => {
      if (!res.ok) throw new Error('Cart error');
      return res.json();
    })
    .then(() => {
      // Fetch updated cart count
      return fetch('/cart.js').then(r => r.json());
    })
    .then(cart => {
      updateCartCount(cart.item_count);
      showToast(`"${name}" toegevoegd aan winkelwagen`);

      if (btnEl) {
        const orig = btnEl.innerHTML;
        btnEl.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><path d="M5 12l5 5L20 7"/></svg> Toegevoegd!';
        btnEl.style.background = '#008f45';
        setTimeout(() => { btnEl.innerHTML = orig; btnEl.style.background = ''; }, 1800);
      }
    })
    .catch(err => {
      console.error('Add to cart failed:', err);
      showToast('Er ging iets mis. Probeer het opnieuw.');
    });
  }


  /* =============================================
     PRODUCT GRID — Quick add to cart buttons
  ============================================= */
  document.querySelectorAll('.btn-cart').forEach(btn => {
    btn.addEventListener('click', e => {
      e.preventDefault();
      const variantId = btn.getAttribute('data-variant-id');
      const name      = btn.getAttribute('data-name') || 'Product';
      if (!variantId) {
        // Fallback: navigate to product page
        const card = btn.closest('.product-card');
        const link = card && card.querySelector('a.product-img-link, a[href]');
        if (link) window.location.href = link.href;
        return;
      }
      addToCartShopify(variantId, 1, name, btn);
    });
  });


  /* =============================================
     PDP — Add to cart (uses <form> via Shopify)
     Intercepts form submit for Ajax behaviour.
  ============================================= */
  const addToCartForm = document.getElementById('AddToCartForm');
  const pdpAddBtn     = document.getElementById('pdpAddToCart');
  const qtyInput      = document.getElementById('qtyInput');

  if (addToCartForm && pdpAddBtn) {
    addToCartForm.addEventListener('submit', e => {
      e.preventDefault();
      const variantId = document.getElementById('variantId').value;
      const qty       = parseInt(qtyInput ? qtyInput.value : 1) || 1;
      const name      = document.querySelector('.pdp-title')?.textContent?.trim() || 'Product';

      // Button feedback during fetch
      const orig = pdpAddBtn.innerHTML;
      pdpAddBtn.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" class="spin"><circle cx="12" cy="12" r="10" stroke-dasharray="40 20"/></svg> Toevoegen...';
      pdpAddBtn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: qty })
      })
      .then(res => {
        if (!res.ok) throw new Error('Cart error');
        return res.json();
      })
      .then(() => fetch('/cart.js').then(r => r.json()))
      .then(cart => {
        updateCartCount(cart.item_count);
        const qtyTxt = qty > 1 ? `${qty}× ` : '';
        showToast(`${qtyTxt}${name} toegevoegd`);

        pdpAddBtn.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><path d="M5 12l5 5L20 7"/></svg> Toegevoegd!';
        pdpAddBtn.style.background = '#008f45';
        pdpAddBtn.disabled = false;
        setTimeout(() => { pdpAddBtn.innerHTML = orig; pdpAddBtn.style.background = ''; }, 2000);
      })
      .catch(() => {
        pdpAddBtn.innerHTML = orig;
        pdpAddBtn.disabled = false;
        showToast('Er ging iets mis. Probeer het opnieuw.');
      });
    });
  }


  /* =============================================
     QUANTITY CONTROLS
  ============================================= */
  const qtyMinus = document.getElementById('qtyMinus');
  const qtyPlus  = document.getElementById('qtyPlus');

  if (qtyMinus && qtyInput) {
    qtyMinus.addEventListener('click', () => {
      const v = parseInt(qtyInput.value) || 1;
      if (v > 1) { qtyInput.value = v - 1; updateBulkTeaser(v - 1); }
    });
  }

  if (qtyPlus && qtyInput) {
    qtyPlus.addEventListener('click', () => {
      const v = parseInt(qtyInput.value) || 1;
      qtyInput.value = v + 1;
      updateBulkTeaser(v + 1);
    });
  }

  if (qtyInput) {
    qtyInput.addEventListener('change', () => {
      const v = Math.max(1, parseInt(qtyInput.value) || 1);
      qtyInput.value = v;
      updateBulkTeaser(v);
    });
  }

  function updateBulkTeaser(qty) {
    const t = document.getElementById('bulkTeaser');
    if (!t) return;
    const span = t.querySelector('span');
    if (!span) return;
    let msg = '';
    if (qty >= 100) {
      msg = '🎉 <strong>30% korting actief</strong> — u profiteert van de beste staffelprijs!';
    } else if (qty >= 50) {
      msg = '✓ <strong>20% korting actief</strong> — bestel 100+ voor 30% korting';
    } else if (qty >= 25) {
      msg = '✓ <strong>15% korting actief</strong> — bestel 50+ voor 20% korting';
    } else if (qty >= 10) {
      msg = '✓ <strong>10% korting actief</strong> — bestel 25+ voor 15% korting';
    } else {
      const needed = 10 - qty;
      msg = `Voeg nog <strong>${needed}</strong> toe voor <strong>10% staffelkorting</strong> — <a href="/#zakelijk" style="color:var(--blue);font-weight:700;">staffelprijzen bekijken</a>`;
    }
    span.innerHTML = msg;
  }


  /* =============================================
     GALLERY THUMBNAILS
  ============================================= */
  const mainImg = document.getElementById('mainImg');
  document.querySelectorAll('.thumb-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const src = btn.getAttribute('data-img');
      if (mainImg && src) {
        mainImg.style.opacity = '0';
        setTimeout(() => { mainImg.src = src; mainImg.style.opacity = '1'; }, 160);
      }
      document.querySelectorAll('.thumb-btn').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
    });
  });


  /* =============================================
     MOBILE NAV
  ============================================= */
  const mobileMenuBtn = document.getElementById('mobileMenuBtn');
  const mainNav       = document.getElementById('mainNav');

  if (mobileMenuBtn && mainNav) {
    mobileMenuBtn.addEventListener('click', () => {
      const open = mainNav.classList.toggle('open');
      mobileMenuBtn.setAttribute('aria-label', open ? 'Menu sluiten' : 'Menu openen');
    });
  }


  /* =============================================
     SMOOTH SCROLL
  ============================================= */
  document.querySelectorAll('a[href^="#"]').forEach(link => {
    link.addEventListener('click', e => {
      const id = link.getAttribute('href').slice(1);
      const target = document.getElementById(id);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth' });
        if (mainNav && mainNav.classList.contains('open')) {
          mainNav.classList.remove('open');
        }
      }
    });
  });

})();
